import React, { useState, useEffect } from 'react';
import Cabeza from './cabeza'
import '../cssComponentes/Inicio.css';
import { Card, Container, Grid } from '@mui/material';
import InformacionDtl from './informacionDtl';
import Total from './total';
import Totalimg from './totalimg';
import { getCotizacionConsolidada, registrarAceptacion } from '../consumos/sapCotizacion';
import { SOPORTE_WHATSAPP, SOPORTE_WHATSAPP_DISPLAY } from '../variables/variablesConection'
import SubCabeza from './subCabeza';
import Terminos from './terminos';
import Terminosfooter from './terminosfooter';
import { CardMedia, Button, Typography } from '@mui/material';
import { styled } from '@mui/system';
import recarga from '../recursos/Recarga.jpg';
import recarga1 from '../recursos/RecargaAceptarc.jpg';
import recarga2 from '../recursos/RecargaRechazarc.jpg';
import logo from '../recursos/LOGOS SIN SLOGANc.png';

export default function Inicio() {

    // UUID de la cotizacion tomado de la URL (?$cotizacion=...).
    const [cotizacionId] = useState(() =>
        new URLSearchParams(window.location.search).get('$cotizacion')
    );

    const [visible, setVisible] = useState(false)
    const [aceptar, setAceptar] = useState(false)
    const [rechazar, setRechazar] = useState(false)
    const [cerrada, setCerrada] = useState(false)
    const [error, setError] = useState(false)
    const [data, setData] = useState([
        {
            comentario:"",
            zona:"",
            estado: "",
            Fecha: "",
            fechavalides: "",
            Producto: "",
            Linea: "",
            ProductoDescripcion: "",
            Valor: "",
            Cotizacion: "",
            Asesor: "",
            Cliente: "",
            Telefono: "",
            Correo: "",
            Residencia: "",
            Moneda: "",
            Impuesto: "",
            Cantidad: "",
            dtl: {}
        }
    ]);

    useEffect(() => {
        const fetchData = async () => {
            if (!cotizacionId) {
                setError(true);
                return;
            }
            try {
                // Una sola llamada al backend: ya viene consolidada.
                const { cerrada: estaCerrada, data: datos } = await getCotizacionConsolidada(cotizacionId);
                if (estaCerrada) {
                    setData(datos);
                    setCerrada(true);
                } else {
                    setData(datos);
                    setVisible(true);
                }
            } catch (e) {
                console.error('Error al obtener datos:', e);
                setError(true);
            }
        };
        fetchData();
        // El correo de "cotizacion cerrada" ahora lo envia el backend (al responder 410).
    }, [cotizacionId]);


    return (
        <div style={{ backgroundColor: "white" }}>
            {visible && aceptar && !cerrada ? <Card id="containerTamaño">
                <div className="box"> <Cabeza data={data}></Cabeza> </div>
                <div className="box"> <SubCabeza data={data}></SubCabeza> </div>
                <div className="box" ><InformacionDtl data={data}></InformacionDtl></div>
                <div className="box"> <Totalimg data={data}></Totalimg> </div>
                <div className="box"> <Total data={data}></Total> </div>
                <div className="box"> <Terminos data={data}></Terminos> </div>
                <div className="box"> <Terminosfooter data={data}></Terminosfooter> </div>
            </Card> : rechazar ?
                <div style={{ height: '100vh', backgroundColor: 'white', display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
                    <Card id="containerTamañov2" style={{ borderTop: '6px solid red', width: '60%', textAlign: 'center', padding: '20px' }}>
                        <Grid container direction="column" alignItems="center" justify="center">
                            <Grid item>
                                <img src={logo} alt={""} style={{ width: '50%', height: 'auto' }} /><br />
                                <Typography
                                    variant="h9"
                                    color="text.primary">
                                    Usted ha rechazado nuestra política para el tratamiento de datos personales, por lo tanto no podemos continuar con la propuesta comercial.
                                    Si cambia de opinión, puede acceder a ella nuevamente en el link que le fue suministrado a su correo electrónico.
                                    En caso de tener dudas, también puede contactar a su asesor comercial asignado o al celular<a
                                        href={`https://api.whatsapp.com/send?phone=${SOPORTE_WHATSAPP}&text=Hola`}
                                        target="_blank"
                                        rel="noopener noreferrer"
                                    > <b> {SOPORTE_WHATSAPP_DISPLAY} </b> </a> .
                                </Typography><br /><br />
                            </Grid>
                        </Grid>
                    </Card>
                </div>
                : cerrada ?
                    <div style={{ height: '100vh', backgroundColor: 'white', display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
                        <Card id="containerTamañov2" style={{ borderTop: '6px solid red', width: '60%', textAlign: 'center', padding: '20px' }}>
                            <Grid container direction="column" alignItems="center" justify="center">
                                <Grid item>
                                    <img src={logo} alt={""} style={{ width: '25%', height: 'auto' }} /><br />
                                    <Typography
                                        variant="h9"
                                        color="text.primary"
                                        sx={{ display: 'block' }}>
                                            Señor usuario, su cotización ha caducado. Puede ponerse en contacto con su asesor comercial asignado o contactar a la mesa de ayuda presionando el siguiente botón.
                                    </Typography>
                                    <Button
                                        variant="contained"
                                        sx={{ mt: 3, mb: 2, backgroundColor: '#dd182b', '&:hover': { backgroundColor: '#b91423' } }}
                                        href={`https://api.whatsapp.com/send?phone=${SOPORTE_WHATSAPP}&text=${encodeURIComponent(`Hola, mi cotización N° ${data[0].Cotizacion} ha caducado y quisiera más información.`)}`}
                                        target="_blank"
                                        rel="noopener noreferrer"
                                    >
                                        Mesa de ayuda
                                    </Button><br />
                                </Grid>
                            </Grid>
                        </Card>
                    </div>
                    : error ?
                    <div style={{ height: '100vh', backgroundColor: 'white', display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
                        <Card id="containerTamañov2" style={{ borderTop: '6px solid red', width: '60%', textAlign: 'center', padding: '20px' }}>
                            <Grid container direction="column" alignItems="center" justify="center">
                                <Grid item>
                                    <img src={logo} alt={""} style={{ width: '25%', height: 'auto' }} /><br />
                                    <Typography variant="h9" color="text.primary" sx={{ display: 'block' }}>
                                        ¡Oops! Parece que no pudimos generar esta cotización. Por favor contacta a nuestra mesa de ayuda presionando el siguiente botón.
                                    </Typography>
                                    <Button
                                        variant="contained"
                                        sx={{ mt: 3, mb: 2, backgroundColor: '#dd182b', '&:hover': { backgroundColor: '#b91423' } }}
                                        href={`https://api.whatsapp.com/send?phone=${SOPORTE_WHATSAPP}&text=${encodeURIComponent(cotizacionId ? `Hola, mi cotización N° ${cotizacionId} no se generó correctamente.` : 'Hola, no logré generar mi cotización y necesito ayuda.')}`}
                                        target="_blank"
                                        rel="noopener noreferrer"
                                    >
                                        Mesa de ayuda
                                    </Button><br />
                                </Grid>
                            </Grid>
                        </Card>
                    </div>
                    :
                    <div style={{ height: '100vh', backgroundColor: 'white', display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
                        <Card id="containerTamañov2" style={{ borderTop: '6px solid red', width: '60%', textAlign: 'center', padding: '20px' }}>
                            <Grid container direction="column" alignItems="center" justify="center">
                                {/* Contenido de tu Card */}
                                <Grid item>
                                    <img src={logo} alt={""} style={{ width: '50%', height: 'auto' }} /><br />
                                    <Typography
                                        variant="h9"
                                        color="text.primary">
                                        Usted recibe la siguiente oferta comercial por solicitud propia y de esta forma acepta nuestras politicas de tratamiento de datos personales publicada en el siguiente <a
                                            href={`https://www.citalsa.com/pages/politica-para-el-tratamiento-de-datos-personales`}
                                            target="_blank"
                                            rel="noopener noreferrer"
                                        > <b>link, </b> </a>
                                        de lo contrario es importante que reporte inmediatamente el incidente al siguiente correo
                                        electrónico: servicioalcliente@talsa.com.co.
                                    </Typography><br /><br />
                                </Grid>
                                <Grid item container spacing={2} justify="center">
                                    <Grid item xs={4}>
                                    </Grid>
                                    <Grid container spacing={2}>
                                        <Grid item xs={3}>
                                        </Grid>
                                        <Grid item xs={6}>
                                            <Grid container spacing={2}>
                                                <Grid item xs={6}>
                                                    <Button onClick={() => {
                                                        registrarAceptacion(cotizacionId, 'aceptado')
                                                        setAceptar(true)
                                                    }}>
                                                        <img src={recarga1} alt={""} style={{ width: '100%', height: 'auto' }} />
                                                    </Button>
                                                    {aceptar && !visible ? <Typography id="cargandoidtxt">Cargando...</Typography> : ""}
                                                </Grid>
                                                <Grid item xs={6}>
                                                    <Button onClick={() => {
                                                        registrarAceptacion(cotizacionId, 'rechazado')
                                                        setRechazar(true)
                                                    }}>
                                                        <img src={recarga2} alt={""} style={{ width: '100%', height: 'auto' }} />
                                                    </Button>
                                                </Grid>
                                            </Grid>
                                        </Grid>
                                        <Grid item xs={3}>
                                        </Grid>
                                    </Grid>
                                </Grid>
                            </Grid>
                        </Card>
                    </div>
            }
        </div>
    );
}
